<script>
  import EmailList from "../EmailList/EmailList.svelte";
  import {External, M} from "../external";

  export let change;

  export function setData(newData) {
    if (tab === "my") {
      categories = null;
      selectedCategory = 0;
      data = newData;
    } else {
      let allItemsSet = {};
      let allItems = [];
      let cats = [
        {
          name: M.ALL,
          id: 0,
          items: allItems
        }
      ];
      (newData || []).forEach(function (category) {
        let locale = External.userLocale === "da_JK" ? "da" : External.userLocale;
        if (External.userLocale === "zh_JO") External.usedLocale = "zh";
        locale = locale || "en";

        let name = (category.name || {})[locale] || (category.name || {})['en'] || "";

        let items = [];
        (category.items || []).forEach(function (item) {
          let emailItem = {
            staticImage: item.image,
            name: item.id
          };

          items.push(emailItem);
          if (!allItemsSet[item.id]) {
            allItemsSet[item.id] = [item.id];
            allItems.push(emailItem);
          }
        });

        let cat = {
          name: name,
          id: category.id,
          items: items
        };
        cats.push(cat);
      });
      categories = cats;
      if (cats.length > 0) {
        selectedCategory = cats[0].id;
        onCategoryChange();
      }
    }
  }

  let onCategoryChange = function () {
    for (let idx = 0; idx < categories.length; ++idx) {
      if (categories[idx].id === selectedCategory) {
        data = {
          templates: categories[idx].items
        };
        break;
      }
    }
  };

  let categories = null;
  let selectedCategory = 0;
  let data = null;
  let tab = "system";
  let useStaticImage = true;
  let tooltipOptions = {
    my: [
      { text: M.CREATE_CAMPAIGN, icon: "fa-plus", tag: "create" },
      { text: M.CLONE, icon: "fa-copy", tag: "clone" },
      { text: M.DELETE_TITLE, icon: "fa-trash", tag: "delete" }
    ],
    system: [
      { text: M.CREATE_CAMPAIGN, icon: "fa-plus", tag: "create" },
      { text: M.CLONE, icon: "fa-copy", tag: "clone" }
    ]
  };

  let onTabChange = function (t) {
    tab = t;
    useStaticImage = tab !== "my";
    data = null;
    change(t);
  };

  let onClick = function (name, action) {
    if (!action) {
      if (tab === "my") {
        External.CPanel.goToUrl("/me/crm/marketing/builder?name=" + name, true);
      } else {
        let url = "https://" + External.subdomain + "." + External.domain + "/me/email?name=" + name + "&is_template=true&preview=1";
        External.Tools.showWebsitePreviewPopup({
          url: url,
          buttonText: M.START_CAMPAIGN,
          onButtonAction: function () {
            External.CPanel.goToUrl("/me/crm/marketing/campaign?type=predefined&template=" + name, true);
          }
        });
      }
    } else if (action === "clone") {
      let params = (tab === "my" ? "" : "&is_template=true") + "&clone=true";
      External.CPanel.goToUrl("/me/crm/marketing/builder?name=" + name + params, true);
    } else if (action === "delete") {
      External.Tools.makeWebsiteRequest({
        action: "deleteEmailTemplate",
        data: {
          name: name
        },
        onOk: function () {
          change(tab);
        }
      });
    } else if (action === "create") {
      let params = tab === "my" ? "&type=my" : "&type=predefined";
      External.CPanel.goToUrl("/me/crm/marketing/campaign?template=" + name + params);
    }
  };
</script>

<div class="col20 f-left email-section-description none">
  {tab === "my" ? M.ALL_YOUR_EMAIL_TEMPLATES : M.ALL_SYSTEM_TEMPLATES}
</div>
<ul class="upper-navigation upper-navigation-full">
  <li><a class:active={tab === "system"} on:click={() => onTabChange("system")}>{M.SYSTEM_TEMPLATES}</a></li>
  <li><a class:active={tab === "my"} on:click={() => onTabChange("my")}>{M.MY_TEMPLATES}</a></li>
</ul>

{#if tab !== "my" && categories !== null && categories.length}
  <div class="col20 f-left">
    <select
      bind:value={selectedCategory}
      on:change={onCategoryChange}
      style="width: 200px; float: right; margin-right: 1%; margin-top: 0;"
    >
      {#each categories as category (category.id)}
        <option value={category.id}>{category.name}</option>
      {/each}
    </select>
  </div>
{/if}

{#if data != null}
  <EmailList {data} tooltipOptions={tooltipOptions[tab]} {onClick} {useStaticImage} />
{/if}
